// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__lu-method[data-v-45237216]{display:flow-root!important}.img__cover-image[data-v-45237216]{max-width:480px;max-height:300px}", ""]);
// Exports
module.exports = exports;
